import React, { Component } from 'react';
import memoizeOne from 'memoize-one';
import { Link } from 'react-router-dom';
import withSounds from 'containers/withSounds';
import HomeIconExit from 'components/HomeExitIcon';
import AuctionsIconSVG from 'resources/FeatureIcons/Button-Auctions.svg';
import CVGlobe from 'resources/FeatureIcons/CasinoverseGlobe.webp';
import DrawingsIconSVG from 'resources/FeatureIcons/Button-Drawings.svg';
import GamesIconSVG from 'resources/FeatureIcons/Button-Games.svg';
import PromoPerksIconSVG from 'resources/FeatureIcons/Button-PromoPerks.svg';
import QuestsIconSVG from 'resources/FeatureIcons/Button-Quests.svg';
import TournamentsIconSVG from 'resources/FeatureIcons/Button-Tournaments.svg';
import VideosIconSVG from 'resources/FeatureIcons/Button-Videos.svg';
import WStoreIconSVG from 'resources/FeatureIcons/Button-WStore.svg';
import './HomeIconsView.css';

const animationClasses = ['anim1', 'anim2', 'anim3', 'anim4'];
const animationInterval = 8000;
const LinkWithSounds = withSounds({ mouseUpSound: true })(Link);
const AWithSounds = withSounds({ mouseUpSound: true })('a');

const baseIcons = {
  games: {
    displayName: 'Games',
    path: '/slots',
    image: GamesIconSVG
  },
  tournaments: {
    displayName: 'Tournaments',
    path: '/tournaments',
    image: TournamentsIconSVG
  },
  auctions: {
    displayName: 'Auctions',
    path: '/auctions',
    image: AuctionsIconSVG
  },
  drawings: {
    displayName: 'Drawings',
    path: '/drawings',
    image: DrawingsIconSVG
  },
  quests: {
    displayName: 'Quests',
    path: '/quests',
    image: QuestsIconSVG
  },
  wstore: {
    displayName: 'WStore',
    path: '/wstore',
    image: WStoreIconSVG
  },
  promoPerks: {
    displayName: 'Promo Perks',
    path: '/promo-perks',
    image: PromoPerksIconSVG
  },
  videos: {
    displayName: 'Videos',
    path: '/videos',
    image: VideosIconSVG
  },
  casinoverse: {
    displayName: 'Casinoverse',
    path: '/about-casinoverse',
    image: CVGlobe
  }
};

const generateHomeIcons = () => [
  baseIcons.games,
  baseIcons.tournaments,
  baseIcons.auctions,
  baseIcons.drawings,
  baseIcons.quests
];

const generateOldHomeIcons = () => [
  baseIcons.games,
  baseIcons.wstore,
  baseIcons.quests,
  baseIcons.promoPerks,
  baseIcons.tournaments,
  baseIcons.auctions,
  baseIcons.drawings,
  baseIcons.videos,
  baseIcons.casinoverse
];

class HomeIconsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idleAnimClass: 'initial-fade ' + this.getRandomAnimation(),
      prevLocation: ''
    };

    this.handleExitButton = this.handleExitButton.bind(this);
    this.generateHomeIconsMemo = memoizeOne(generateHomeIcons);
    this.generateOldHomeIconsMemo = memoizeOne(generateOldHomeIcons);
  }

  getRandomAnimation() {
    return (
      'idle-anim ' +
      animationClasses[Math.floor(Math.random() * animationClasses.length)]
    );
  }

  startRandomIdleAnimation() {
    const { location } = this.props;
    this.setState({
      idleAnimClass: ''
    });
    if (location.pathname !== '/') {
      clearTimeout(this.idleAnimResetTimeout);
    } else {
      this.idleAnimResetTimeout = setTimeout(() => {
        this.setState({
          idleAnimClass: this.getRandomAnimation()
        });
      }, 200);
    }
  }

  componentDidMount() {
    this.idleAnimInterval = setInterval(() => {
      this.startRandomIdleAnimation();
    }, animationInterval);
  }

  componentWillUnmount() {
    clearInterval(this.idleAnimInterval);
    clearTimeout(this.idleAnimResetTimeout);
    clearTimeout(this.exitTimeout);
  }

  handleExitButton() {
    this.setState({
      prevLocation: this.props.location.pathname,
      idleAnimClass: ''
    });
    this.exitTimeout = setTimeout(() => {
      this.setState({ prevLocation: '' });
    }, 1000);
  }

  render() {
    const { location, homeLayoutUpdateEnabled } = this.props;
    const { prevLocation, idleAnimClass } = this.state;

    let iconData = homeLayoutUpdateEnabled
      ? this.generateHomeIconsMemo()
      : this.generateOldHomeIconsMemo();

    if (!iconData) {
      return null;
    }

    const iconRoutes = iconData.map((icon, index) => {
      let iconClass = 'home-icon-link';

      if (location.pathname !== '/') {
        iconClass += ' fade-all-icons';
      } else if (prevLocation === icon.path) {
        iconClass += ' move-back';
      }

      let LinkComponent;
      let linkProps;
      if (icon.path.startsWith('https://')) {
        LinkComponent = AWithSounds;
        linkProps = { href: icon.path };
      } else {
        LinkComponent = LinkWithSounds;
        linkProps = {
          to: { pathname: icon.path, state: { initiator: 'home-page-icon' } }
        };
      }

      const iconSubtext =
        icon.displayName === 'Casinoverse' ? 'Get The App' : icon.displayName;

      return (
        <LinkComponent
          {...linkProps}
          key={index}
          className={iconClass}
          tabIndex={location.pathname !== '/' ? -1 : undefined}
        >
          <div className="home-icon-wrapper">
            <img src={icon.image} alt={icon.displayName} />
            <div className="home-icon-text">{iconSubtext}</div>
            {icon.displayName === 'Casinoverse' && (
              <span className="casinoverse-icon-text">CASINOVERSE</span>
            )}
          </div>
        </LinkComponent>
      );
    });

    let exitClassname = `home-icons-exit-icon`;
    if (location.pathname === '/') {
      exitClassname += ' exit-fade-icon';
    }

    const containerClass = `home-icons-${
      homeLayoutUpdateEnabled ? 'row' : 'container'
    } length-${iconRoutes.length} ${
      location.pathname === '/' ? idleAnimClass : ''
    }`;

    return homeLayoutUpdateEnabled ? (
      <div className="home-icons-view-wrapper">
        <div className="home-icons-view-title">Play & Earn</div>
        <div className={containerClass}>{iconRoutes}</div>
      </div>
    ) : (
      <div className={containerClass}>
        {iconRoutes}
        <HomeIconExit
          url="/"
          className={exitClassname}
          onClick={this.handleExitButton}
        />
      </div>
    );
  }
}

export default HomeIconsView;
